import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2e06f698"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "hr-preview-panel__header"
}
const _hoisted_2 = ["aria-expanded", "aria-controls", "title"]
const _hoisted_3 = { "aria-hidden": "true" }
const _hoisted_4 = ["aria-label"]
const _hoisted_5 = ["id"]
const _hoisted_6 = {
  key: 0,
  role: "status"
}
const _hoisted_7 = {
  key: 1,
  class: "preview-error",
  role: "alert"
}
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Повторить")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("Скачать оригинал")
const _hoisted_10 = ["src", "title"]
const _hoisted_11 = { class: "image-toolbar" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode("−")
const _hoisted_13 = /*#__PURE__*/_createTextVNode("+")
const _hoisted_14 = /*#__PURE__*/_createTextVNode("По размеру окна")
const _hoisted_15 = { class: "image-scroll" }
const _hoisted_16 = ["src", "alt"]

import { computed, onBeforeUnmount, onMounted, ref, watch } from "vue";
import Modal from "@/components/common/Modal.vue";
import PdfViewer from "@/components/common/PdfViewer.vue";
import { Button } from "@/components/common";
import HrDataService from "@/services/hr/HrDataService";
import { HrEmployeeDocument } from "@/types/hr/Hr";
import { hrPreviewKind } from "@/utils/hrFilePreview";
import { t } from "@/i18n";


export default /*#__PURE__*/_defineComponent({
  props: {
    employeeId: null,
    document: null
  },
  emits: ["close", "download"],
  setup(__props: any, { emit }) {

const props = __props as { employeeId: string; document: HrEmployeeDocument }

/* eslint-disable @typescript-eslint/no-unused-vars */


const title = computed(() => props.document.fileName || props.document.esignDocumentTitle || "Предпросмотр документа");
const panelId = computed(() => `hr-preview-${props.employeeId}-${props.document.id}`);
function mobileScreen() {
  return (typeof window !== "undefined" && Boolean(window.matchMedia?.("(max-width: 768px)").matches))
    || (typeof navigator !== "undefined" && (/Android|iPhone|iPad|iPod|Mobile/i.test(navigator.userAgent)
      || (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1)));
}
const isMobile = ref(mobileScreen());
const expanded = ref(true);
function updateScreen() { isMobile.value = mobileScreen(); }
const loading = ref(false);
const error = ref("");
const imageUrl = ref("");
const pdfBlob = ref<Blob | null>(null);
const pdfUrl = ref("");
const zoom = ref(1);
const pdfReady = computed(() => !loading.value && !error.value && Boolean(pdfBlob.value));
let generation = 0;

function release() {
  if (imageUrl.value) URL.revokeObjectURL(imageUrl.value);
  if (pdfUrl.value) URL.revokeObjectURL(pdfUrl.value);
  imageUrl.value = "";
  pdfUrl.value = "";
  pdfBlob.value = null;
}
async function load() {
  const current = ++generation;
  release(); loading.value = true; error.value = ""; zoom.value = 1; expanded.value = true;
  try {
    const response = await HrDataService.previewEmployeeDocument(props.employeeId, props.document.id);
    if (current !== generation) return;
    const blob = response.data as Blob;
    const mime = String(response.headers?.["content-type"] || blob.type || "").split(";")[0].toLowerCase().trim();
    const kind = hrPreviewKind(mime);
    if (!blob.size || !kind) throw new Error("Этот формат не поддерживает предпросмотр. Скачайте оригинал.");
    const content = blob.type === mime ? blob : new Blob([blob], { type: mime });
    if (kind === "pdf") { pdfBlob.value = content; pdfUrl.value = URL.createObjectURL(content); }
    else imageUrl.value = URL.createObjectURL(content);
  } catch (exception: unknown) {
    if (current !== generation) return;
    const response = exception as { response?: { data?: Blob | { message?: string } }; message?: string };
    let message: string | undefined;
    const data = response.response?.data;
    if (data instanceof Blob) {
      try { message = JSON.parse(await data.text()).message; } catch { /* Non-JSON gateway error. */ }
    } else message = data?.message;
    if (current === generation) error.value = message || (!response.response && response.message) || "Не удалось открыть файл. Повторите попытку или скачайте оригинал.";
  } finally {
    if (current === generation) loading.value = false;
  }
}
watch(() => [props.employeeId, props.document.id], load, { immediate: true });
function onKeydown(event: KeyboardEvent) {
  if (event.key === "Escape" && isMobile.value && !pdfReady.value) emit("close");
}
onMounted(() => { window.addEventListener("keydown", onKeydown); window.addEventListener("resize", updateScreen); });
onBeforeUnmount(() => { ++generation; release(); window.removeEventListener("keydown", onKeydown); window.removeEventListener("resize", updateScreen); });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(), _createBlock(_resolveDynamicComponent(isMobile.value ? Modal : 'section'), _mergeProps(isMobile.value ? { show: !_unref(pdfReady), title: _unref(title), wide: true } : { class: 'hr-preview-panel', role: 'region', 'aria-label': _unref(title) }, {
      onClose: _cache[7] || (_cache[7] = ($event: any) => (emit('close')))
    }), {
      default: _withCtx(() => [
        (!isMobile.value)
          ? (_openBlock(), _createElementBlock("header", _hoisted_1, [
              _createElementVNode("button", {
                type: "button",
                class: "hr-preview-panel__toggle",
                "aria-expanded": expanded.value,
                "aria-controls": _unref(panelId),
                title: _unref(title),
                onClick: _cache[0] || (_cache[0] = ($event: any) => (expanded.value = !expanded.value))
              }, [
                _createElementVNode("span", _hoisted_3, _toDisplayString(expanded.value ? '▾' : '▸'), 1),
                _createElementVNode("span", null, _toDisplayString(_unref(title)), 1)
              ], 8, _hoisted_2),
              _createElementVNode("button", {
                type: "button",
                class: "hr-preview-panel__close",
                "aria-label": _unref(t)('common.close'),
                onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('close')))
              }, "×", 8, _hoisted_4)
            ]))
          : _createCommentVNode("", true),
        _withDirectives(_createElementVNode("div", {
          id: _unref(panelId),
          class: "hr-file-preview"
        }, [
          (loading.value)
            ? (_openBlock(), _createElementBlock("p", _hoisted_6, "Подготовка предпросмотра… Для Word-файла может потребоваться конвертация в PDF."))
            : (error.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createElementVNode("p", null, _toDisplayString(error.value), 1),
                  _createVNode(_unref(Button), {
                    type: "button",
                    onClick: load
                  }, {
                    default: _withCtx(() => [
                      _hoisted_8
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(Button), {
                    type: "button",
                    variant: "default",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (emit('download')))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_9
                    ]),
                    _: 1
                  })
                ]))
              : (pdfUrl.value && !isMobile.value)
                ? (_openBlock(), _createElementBlock("iframe", {
                    key: 2,
                    src: pdfUrl.value,
                    title: _unref(title),
                    class: "hr-preview-panel__pdf"
                  }, null, 8, _hoisted_10))
                : (imageUrl.value)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                      _createElementVNode("div", _hoisted_11, [
                        _createVNode(_unref(Button), {
                          type: "button",
                          variant: "default",
                          disabled: zoom.value <= 0.5,
                          onClick: _cache[3] || (_cache[3] = ($event: any) => (zoom.value = Math.max(0.5, zoom.value - 0.25)))
                        }, {
                          default: _withCtx(() => [
                            _hoisted_12
                          ]),
                          _: 1
                        }, 8, ["disabled"]),
                        _createElementVNode("span", null, _toDisplayString(Math.round(zoom.value * 100)) + "%", 1),
                        _createVNode(_unref(Button), {
                          type: "button",
                          variant: "default",
                          disabled: zoom.value >= 3,
                          onClick: _cache[4] || (_cache[4] = ($event: any) => (zoom.value = Math.min(3, zoom.value + 0.25)))
                        }, {
                          default: _withCtx(() => [
                            _hoisted_13
                          ]),
                          _: 1
                        }, 8, ["disabled"]),
                        _createVNode(_unref(Button), {
                          type: "button",
                          variant: "default",
                          onClick: _cache[5] || (_cache[5] = ($event: any) => (zoom.value = 1))
                        }, {
                          default: _withCtx(() => [
                            _hoisted_14
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("div", _hoisted_15, [
                        _createElementVNode("img", {
                          src: imageUrl.value,
                          alt: _unref(title),
                          style: _normalizeStyle({ width: `${zoom.value * 100}%` }),
                          onError: _cache[6] || (_cache[6] = ($event: any) => (error.value = 'Не удалось отобразить изображение. Попробуйте скачать оригинал.'))
                        }, null, 44, _hoisted_16)
                      ])
                    ], 64))
                  : _createCommentVNode("", true)
        ], 8, _hoisted_5), [
          [_vShow, isMobile.value || expanded.value]
        ])
      ]),
      _: 1
    }, 16)),
    _createVNode(PdfViewer, {
      show: isMobile.value && _unref(pdfReady),
      source: pdfBlob.value,
      title: _unref(title),
      onClose: _cache[8] || (_cache[8] = ($event: any) => (emit('close')))
    }, null, 8, ["show", "source", "title"])
  ], 64))
}
}

})